<template>
  <div class="pay-center-item-component"
       :class="[
         `pay-center-item-component--${size}`
       ]"
       @click="handleClick"
  >
    <div class="pay-center-item-title">
      {{ title }}
    </div>
    <div class="pay-center-item-value"
         :class="[
           { 'strong-value': strongValue },
         ]"
    >
      <slot></slot>
      <ym-icon v-if="isLink"
               class="pay-center-item-icon"
               name="right"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PayCenterItem',
    props: {
      title: {
        type: String,
        required: true,
      },
      size: {
        type: String,
        default: 'normal',
        validator(val) {
          return [
            'normal',
            'small',
          ].includes(val);
        },
      },
      strongValue: Boolean,
      isLink: Boolean,
    },
    methods: {
      handleClick(e) {
        this.$emit('click', e);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .pay-center-item {
    &-component {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: @font-size-base;

      &--normal {
        padding: @size-base 0;
      }

      &--small {
        padding: 0;
      }
    }

    &-title {
      flex-shrink: 0;
      margin-right: @size-small;
    }

    &-value {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      color: @color-text-lighter;

      &.strong-value {
        color: @color-text-light;
      }
    }

    &-icon {
      margin: 0 -2px 0 @size-extra-small;
      font-size: @font-size-small;
      color: @color-text-lighter;
    }
  }
</style>
